import { getLogs, Log } from 'api/logApi';
import { useLoginContext } from 'components/providers/loginContext';
import { FORMAT_DATE_SLASH } from 'constants/constants';
import { useCallback, useState } from 'react';
import { convertDate } from 'utils/commonService';

// 指定した WF アプリの実行ジョブのログを取得する
export function useGetLogs(): [
  (wfId: number, page: number, itemsPerPage: number) => Promise<void>,
  Log[],
  boolean,
  boolean,
  any
] {
  const loginContext = useLoginContext();
  const [logs, setLogs] = useState<Log[]>([]);
  const [error, setError] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const handleGetLogs = useCallback(
    async (wfId: number, page: number, itemsPerPage: number): Promise<void> => {
      setLoading(true);
      try {
        if (loading) return;

        //ログ取得
        const loadedLogs = await getLogs(
          wfId,
          page,
          itemsPerPage,
          loginContext
        );

        // 日付フォーマット変換
        loadedLogs.forEach((log) => {
          log.executeAtUTCKey = convertDate(
            log.executeAtUTCKey,
            FORMAT_DATE_SLASH
          );
          log.executeEndAtUTC = convertDate(
            log.executeEndAtUTC,
            FORMAT_DATE_SLASH
          );
        });

        setLogs((current) => {
          return [...current, ...loadedLogs];
        });
        setHasMore(loadedLogs.length > 0);
        setError(undefined);
        setLoading(false);
      } catch (e) {
        setError(e);
        setHasMore(false);
        setLoading(false);
      }
    },
    [loading, loginContext]
  );

  return [handleGetLogs, logs, loading, hasMore, error];
}
